"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceLg, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
const StyledContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: SpaceLg,
  maxWidth: "470px"
});
const StyledRowContainer = styled(Box)({
  display: "flex",
  gap: SpaceLg
});
const StyledProductsContainer = styled("ul")({
  display: "flex",
  flexGrow: 1,
  gap: SpaceLg,
  margin: 0,
  padding: 0
});
const StyledButtonsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: SpaceMd,
  minWidth: "112px",
  width: "112px"
});
export {
  StyledButtonsContainer,
  StyledContainer,
  StyledProductsContainer,
  StyledRowContainer
};
